import type { IUserField } from '../types'

export const userFields: IUserField[] = [
  {
    name: 'user.email',
    labelKey: 'forms.warehouseman.email-title',
    placeholderKey: 'forms.warehouseman.email',
    model: 'email',
    type: 'email',
  },
  {
    name: 'user.name',
    labelKey: 'forms.warehouseman.name-title',
    placeholderKey: 'forms.warehouseman.name',
    model: 'name',
    type: 'text',
  },
  {
    name: 'user.surname',
    labelKey: 'forms.warehouseman.surname-title',
    placeholderKey: 'forms.warehouseman.surname',
    model: 'surname',
    type: 'text',
  },
  {
    name: 'user.middlename',
    labelKey: 'forms.warehouseman.middlename-title',
    placeholderKey: 'forms.warehouseman.middlename',
    model: 'middlename',
    type: 'text',
  },
  {
    name: 'user.is_active',
    labelKey: 'forms.warehouseman.is_active-title',
    placeholderKey: 'forms.warehouseman.is_active',
    model: 'is_active',
    items: ['active', 'inactive'],
    type: 'text',
    component: 'InputSelect',
  },
  {
    name: 'user.phone',
    labelKey: 'forms.warehouseman.phone-title',
    placeholderKey: 'forms.warehouseman.phone',
    model: 'phone',
    type: 'tel',
    component: 'PhoneNumberInput',
    countryFormats: true,
  },
  {
    name: 'user.password',
    labelKey: 'forms.warehouseman.password-title',
    placeholderKey: 'forms.warehouseman.password',
    model: 'password',
    type: 'password',
  },
]
